import { Column } from "../objects/column";
import { CompanyCode, codeType } from "../objects/companyCode";
import { CompanyCodeErrors } from "../objects/companyCodeErrors";
import { CompanyCodeListConfiguration } from "../objects/companyCodeListConfiguration";
import { CompanyCodeListCriteria } from "../objects/companyCodeListCriteria";
import { CompanyCodeListFiltersCriteria } from "../objects/companyCodeListFiltersCriteria";

export const EMPTY_COMPANY_CODE: CompanyCode = {
    id: 0,
    code_type: codeType.OS,
    code_value: "",
    code_value_additional: "",
    iata_airline: null,
    start_date: null,
    iata_airport: null,
    created_date: new Date(),
    modified_date: new Date(),
    creator: null,
    last_author: null,
    end_date: null,
    client_branch: undefined,
    iata_country: null,
    class_booking: null
};

export const EMPTY_COMPANY_CODE_FILTERS: CompanyCodeListFiltersCriteria = {
    code_type: "all",
    iata_airline: null,
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    iata_airport: null,
    iata_country: null
};

export const EMPTY_COMPANY_CODE_LIST_CRITERIA: CompanyCodeListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_COMPANY_CODE_FILTERS,
    search: '',
    client_branch: null
};

export const EMPTY_COMPANY_CODE_ERRORS: CompanyCodeErrors = {
    code_value_error: "",
    iata_airline_error: "",
    start_date_error: "",
    end_date_error: ""
};

export const COMPANY_CODE_INFO_ROUTE = '/company-code/edit/:id/info';
export const COMPANY_CODE_CONTACT_ROUTE = '/company-code/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'type',
    field_name: 'CODE_TYPE',
    checked: true,
    order_by: 'code_type',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'code',
    field_name: 'CODE_VALUE',
    checked: true,
    order_by: 'code_value',
    fixed_width: false,
    last_updated: false,
    width: null
},
{
    label: 'airline',
    field_name: 'AIRLINE',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
},
{
    label: 'airport',
    field_name: 'AIRPORT',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
},
{
    label: 'country',
    field_name: 'COUNTRY',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
},
{
    label: 'class-booking',
    field_name: 'CLASS_BOOKING',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
},
{
    label: 'start-date',
    field_name: 'START_DATE',
    checked: true,
    order_by: 'start_date',
    fixed_width: true,
    last_updated: false,
    width: null
},
{
    label: 'end-date',
    field_name: 'END_DATE',
    checked: true,
    order_by: 'end_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_COMPANY_CODE_LIST_CONFIGURATION: CompanyCodeListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const COMPANY_CODE_MODULE = 'COMPANY_CODE';
